import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export interface Props {
  className?: string;
  fillColor?: string;
}

const EmailIcon = (props: Props) => {
  const { className } = props;
  const fillColor = props.fillColor || "#bababa";

  return (
    <SvgIcon className={className} viewBox="0 0 20 16">
      <g transform="matrix(1 0 0 1 -82 -2663 )">
        <path
          d="M 20 2  C 20 0.895  19.105 0  18 0  L 2 0  C 0.895 0  0.00999999999999979 0.895  0 2  L 0 14  C 0 15.105  0.895 16  2 16  L 18 16  C 19.105 16  20 15.105  20 14  L 20 2  Z M 18 2  L 18 4  L 10 9  L 2 4  L 2 2  L 10 7  L 18 2  Z "
          fillRule="nonzero"
          fill={fillColor}
          stroke="none"
          transform="matrix(1 0 0 1 82 2663 )"
        />
      </g>
    </SvgIcon>
  );
};

export default EmailIcon;
